import { Badge } from "antd";
import { PresetStatusColorType } from "antd/es/_util/colors";
import { Status } from "../../../services/client";

export const TaskStatusBadge = ({ status }: { status: Status }) => {
  let badgeStatus: PresetStatusColorType = "default";

  if (status === "DONE") {
    badgeStatus = "success";
  } else if (status === "STARTED") {
    badgeStatus = "processing";
  } else if (status === "FAILED") {
    badgeStatus = "error";
  } else if (status === "CANCELLED") {
    badgeStatus = "error";
  }

  return <Badge status={badgeStatus} text={status} />;
};
